import { Model } from '@contember/schema';
import { formatDataType, formatEntityName, formatFieldName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
import { SchemaDslBuilderError } from '../../SchemaDslBuilder';
import { dataTypesMapping } from './AddColumnStmt';
export const alterColumnStmtInstruction = `
#### Column Type Alteration
- Syntax: \`alter column <entity_name>.<column_name> <data_type> [required];\`
- Example: \`alter column Author.name string;\`

Important notes:
- <data_type> can be built-in type or enum name
`;
export const stmtAlterColumn = ({ entityName, columnName, dataType, nullable }) => {
    if (nullable) {
        return `alter column ${entityName}.${columnName} ${dataType};`;
    }
    return `alter column ${entityName}.${columnName} ${dataType} required;`;
};
export const stmtForHumanAlterColumn = ({ entityName, columnName, dataType, nullable }) => {
    return `Change the type of the column __${columnName}__ in the database table __${entityName}__ to __${dataType}__.` + (nullable ? '' : ' The column is required.');
};
export const alterColumnHandler = createSchemaStatementHandler({
    type: 'alter column',
    parse: line => {
        const match = /^alter column (?<entityName>\w+)\.(?<columnName>\w+) (?<dataType>[\w_]+)(?<required> required)?/.exec(line);
        return match?.groups
            ? {
                type: 'alter column',
                entityName: formatEntityName(match.groups.entityName),
                columnName: formatFieldName(match.groups.columnName),
                dataType: formatDataType(match.groups.dataType),
                nullable: !match.groups.required,
            }
            : null;
    },
    getHumanStmt: stmtForHumanAlterColumn,
    apply: (stmt, builder) => {
        const builtIn = dataTypesMapping[stmt.dataType] ?? null;
        builder.updateSchema(it => {
            if (builtIn) {
                if (!it.schema.model.entities[stmt.entityName]?.fields[stmt.columnName]) {
                    return it.addColumn(stmt.entityName, {
                        type: builtIn,
                        name: stmt.columnName,
                        nullable: !!stmt.nullable,
                    });
                }
                return it.updateColumnType(stmt.entityName, stmt.columnName, {
                    type: builtIn,
                    nullable: !!stmt.nullable,
                });
            }
            if (it.schema.model.enums[stmt.dataType]) {
                if (!it.schema.model.entities[stmt.entityName]?.fields[stmt.columnName]) {
                    return it.addColumn(stmt.entityName, {
                        type: Model.ColumnType.Enum,
                        columnType: stmt.dataType,
                        name: stmt.columnName,
                        nullable: !!stmt.nullable,
                    });
                }
                return it.updateColumnType(stmt.entityName, stmt.columnName, {
                    type: Model.ColumnType.Enum,
                    columnType: stmt.dataType,
                    nullable: !!stmt.nullable,
                });
            }
            throw new SchemaDslBuilderError(`Invalid column type ${stmt.dataType}`);
        });
    },
});
//# sourceMappingURL=AlterColumnStmt.js.map